import { render, staticRenderFns } from "./CouponProducts.vue?vue&type=template&id=24380df5&"
import script from "./CouponProducts.vue?vue&type=script&lang=ts&"
export * from "./CouponProducts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports